import {
  ActionMadeByRole,
  Appointment,
  DevicesCategory,
  ParticipationReportReason,
  Session,
  SessionFormat,
} from './session';
import { Participant } from './participant';
import { Account } from './auth';
import { FormResponse } from './formAnswer';
import { CriterionStatusEnum, Incentive } from '.';

export enum ParticipationStatus {
  INVITED = 'invited',
  APPLIED = 'applied',
  ACCEPTED = 'accepted',
  IN_PROGRESS = 'in_progress',
  BOOKED = 'booked',
  PARTICIPATED = 'participated',

  PAYMENT_REQUESTED = 'payment_requested',
  PROCESSING_PAYMENT = 'processing_payment',
  PAYED = 'payed',

  DECLINED = 'declined',
  CANCELED = 'canceled',
  OUT_OF_QUOTA = 'out_of_quota',
  NO_SHOW = 'noshow',

  NOT_INTERESTED = 'not_interested',
}

export enum ParticipationSource {
  LINK = 'LINK',
  INVITE = 'INVITE',

  ADS = 'ADS',
  TANDEMZ_PANEL = 'TANDEMZ_PANEL',
  MANUAL_RECRUIT = 'MANUAL_RECRUIT',
  REFERRAL = 'REFERRAL',

  PARTNER = 'PARTNER',
}

export enum ValidationChangedReason {
  FRAUD_DETECTED = 'FRAUD_DETECTED',
  CRITERIA_VALIDATION = 'CRITERIA_VALIDATION',
  QUOTA_VALIDATION = 'QUOTA_VALIDATION',
  PARTICPANT_BANNED = 'PARTICPANT_BANNED',
  MANUAL_VALIDATION = 'MANUAL_VALIDATION',
  DEFAULT_BEHAVIOR = 'DEFAULT_BEHAVIOR',
  ALREADY_PARTICIPATED = 'ALREADY_PARTICIPATED',
  GEOIP = 'GEOIP',
}

export enum DeclinedReason {
  FRAUD_DETECTED = 'FRAUD_DETECTED',
  CRITERIA_VALIDATION = 'CRITERIA_VALIDATION',
  PARTICPANT_BANNED = 'PARTICPANT_BANNED',
  MANUAL_VALIDATION = 'MANUAL_VALIDATION',
  DUPLICATED = 'DUPLICATED',
  ALREADY_PARTICIPATED = 'ALREADY_PARTICIPATED',
  GEOIP = 'GEOIP',
}

export interface Participation {
  id: string;
  trackingId: string;
  sessionId: string;
  participantId?: string;
  appointmentId?: string;

  session?: Session;
  participant?: Participant;
  appointment?: Appointment;
  applicationIds?: string[];
  mainApplicationId?: string;
  taskId?: string;

  duration?: number;
  durationDisplayed?: string;
  format?: SessionFormat;
  participantAddress?: string;
  studyLink?: string;
  sessionLinkId?: string;

  // @deprecated
  incentiveId?: string;
  // @deprecated
  incentiveDisplayed?: string;

  incentive: Incentive;
  incentiveText?: string;

  appliedAt?: Date;
  acceptedAt?: Date;
  declinedAt?: Date;
  bookedAt?: Date;
  startedAt?: Date;
  participatedAt?: Date;
  effectiveDuration?: number;
  cancelledAt?: Date;

  source: ParticipationSource;
  sourcePlatform?: string;
  sourceDetails?: string;

  status: ParticipationStatus;
  reportReason?: ParticipationReportReason;
  score?: number;
  declinedReason?: ValidationChangedReason;

  invitedAt?: string;
  invitationReminderSentAt?: string;

  clientGoogleCalendarEventLink?: string;
  cancelledAppointmentId?: string;
  cancelledAppointment?: Appointment;
  cancelledAppointmentReasonGiven?: string;
  cancelledAppointmentResponsible?: ActionMadeByRole;

  notes?: string;
  subscriptionsCount: number;
  tags?: string[];
  billed?: boolean;
  documentsCount: number;

  createdAt: string;
  updatedAt: string;
  updateCausedBy?: string;
  reminderSentAt?: string;

  lastSeenByClientAt: string;
  automaticlyValidateAt: string;
  automaticallyRejectAt?: Date;

  isBackup: boolean;
  selectedDevice?: DevicesCategory;

  tagsIds?: string[];
}

export interface IndexedParticipation extends Participation {
  applicationId?: string;
  firstname?: string;
  lastname?: string;
  fullname?: string;
  email: string;
  meetingDate?: Date;
  meetingVideoCallLink?: string;
  unreachable?: boolean;
  formResponses: FormResponseAnswers[];
  criteriaStatus?: Record<string, CriterionStatusEnum>;
}

export interface Message {
  id: string;
  content: string;
  account?: Account;
  accountId?: string;
  participant?: Participant;
  participantId?: string;
  participation: Participation;
  participationId: string;
  sendAt: string;
  createdAt: string;
  updatedAt: string;
}

export interface FormResponseAnswers {
  fieldRef: string;
  type: string;
  values: string[];
  labels: string[];
  text: string | null;
}
